import { createContext, useContext, useEffect, useId } from "react";
import type { BreadcrumbItem } from "@/lib/pageNavigation";

export interface DetailTitle {
  id: string;
  path: string;
  title: string;
}

interface NavigationContext {
  breadcrumbs: BreadcrumbItem[];
  path: string;
  register: (detail: DetailTitle) => void;
  unregister: (id: string) => void;
}

export const PageNavigationContext = createContext<NavigationContext | null>(null);

export function usePageBreadcrumbs(): BreadcrumbItem[] {
  return useContext(PageNavigationContext)?.breadcrumbs ?? [];
}

/** Register only open drawers and restore the previous title on close/unmount. */
export function useDrawerPageTitle(open: boolean, title: string) {
  const context = useContext(PageNavigationContext);
  const id = useId();
  const register = context?.register;
  const unregister = context?.unregister;
  const path = context?.path;

  useEffect(() => {
    if (!open || path === undefined) return;

    register?.({ id, path, title });
    return () => unregister?.(id);
  }, [open, id, path, title, register, unregister]);
}
